import React from 'react';
import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { translate } from '../../../../types/translation/Translator';
import { FilterProps, FilterStorageKey } from '../common/filter.util';
import { Company } from '../../../../types/company';
import { itemsContainText } from '../../../../util/string.util';
import CompanyPartnerFilterDropdownContent from './DropdownContent/CompanyFilterContent';
import CompanyFilterInnerContent from './DropdownContent/CompanyFilterInnerContent';
import Icon, { IconType } from '../../../../ui/icons/Icon';

export class CompanyPartnerFilter extends BaseFilter<Company> {
  constructor() {
    super(FilterStorageKey.COMPANY_PARTNER);
  }

  toLabel(): string {
    return translate({ key: TranslationKey.partner, count: 'plural' });
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.company?.size || 0;
  }

  toIcon(): JSX.Element {
    return <Icon type={IconType.dataFlow4} size={'size-5'} stroke='stroke-current' />;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return (
      <CompanyPartnerFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CompanyFilterInnerContent filter={this} filterProps={props.filterProps} setFilterProps={props.setFilterProps} />
    );
  }

  search(item: Company, query: string) {
    return itemsContainText(query, [item.name]);
  }

  filteredItems(items: Company[], query: string, filterProps: FilterProps) {
    return items.filter(item => {
      return [this.search(item, query)].every(value => value === null || value);
    });
  }

  static filter(filterProps: FilterProps, item: Company | undefined) {
    if (item && filterProps.company?.size && !filterProps.company.has(item.id)) return false;
    return true;
  }
}
